import { initialPagination } from '@components/shared/Table/components/Pagination/types'
import { parseGetProfilesPaylod } from '../helpers/parseGetProfilesPaylod'
import { parseSavePermissionsPaylod } from '../helpers/parseSavePermissionsPaylod'
import { toast } from '@utils/functions/notificationToast'
import { parseAddNewProfilePayload } from '../helpers/parseAddNewProfilePayload'
import { useAccessProfile } from '.'
import { useLayout } from '@hooks/useLayout'
import { useUser } from '@hooks/useUser'

import type { AccessProfileModalFormProps } from '../components/AccessProfileModal/form/types'
import type { GetProfilesFormDataProps } from './types'
import type { AddNewProfileModalFormProps } from '../components/AddNewProfileModal/form/types'
import type { AxiosError } from 'axios'

import * as apiAccessProfile from '@services/api/accessProfile'

const deleteProfile = async (profileId: number) => {
  const { setIsDeleteProfileLoading } = useAccessProfile.getState()

  setIsDeleteProfileLoading(true)

  try {
    await apiAccessProfile.deleteProfile(profileId)

    toast.success('Perfil deletado com sucesso!')

    getProfiles({
      page: initialPagination.PAGE,
      itemsPerPage: initialPagination.ITEMS_PER_PAGE
    })

    return true
  } catch (error) {
    const errorMessage =
      (error as AxiosError<{ errorMessage: string[] }>)?.response?.data?.errorMessage[0] || 'Falha ao deletar o perfil!'

    toast.error(errorMessage)

    return false
  } finally {
    setIsDeleteProfileLoading(false)
  }
}

const addNewProfile = async (formData: AddNewProfileModalFormProps) => {
  const { setIsAddNewProfileLoading } = useAccessProfile.getState()

  setIsAddNewProfileLoading(true)

  try {
    const payload = parseAddNewProfilePayload(formData)

    await apiAccessProfile.addNewProfile(payload)

    toast.success('Perfil adicionado com sucesso!')

    getProfiles({
      page: initialPagination.PAGE,
      itemsPerPage: initialPagination.ITEMS_PER_PAGE
    })

    return true
  } catch (error) {
    const errorMessage =
      (error as AxiosError<{ errorMessage: string[] }>)?.response?.data?.errorMessage[0] ||
      'Falha ao adicionar o perfil!'

    toast.error(errorMessage)

    return false
  } finally {
    setIsAddNewProfileLoading(false)
  }
}

const savePermissions = async (formData: AccessProfileModalFormProps) => {
  const { setIsSavePermissionsLoading } = useAccessProfile.getState()
  const { userData, getUserPermissions } = useUser.getState()
  const { getSideBarData } = useLayout.getState()

  setIsSavePermissionsLoading(true)

  try {
    const payload = parseSavePermissionsPaylod(formData)

    await apiAccessProfile.savePermissions(payload)

    toast.success('Permissões salvas com sucesso!')

    getProfiles({
      page: initialPagination.PAGE,
      itemsPerPage: initialPagination.ITEMS_PER_PAGE
    })

    getAccessProfileById(formData.profileId?.toString() || '')
    !!userData?.user.id && getUserPermissions(userData?.user.id)
    getSideBarData()
  } catch (error) {
    const errorMessage =
      (error as AxiosError<{ errorMessage: string[] }>)?.response?.data?.errorMessage[0] ||
      'Falha ao salvar as permissões!'

    toast.error(errorMessage)
  } finally {
    setIsSavePermissionsLoading(false)
  }
}

const getAccessProfileById = async (profileId: string) => {
  const { setAccessProfileByIdData, setIsAccessProfileByIdLoading } = useAccessProfile.getState()

  setIsAccessProfileByIdLoading(true)

  try {
    const data = await apiAccessProfile.getAccessProfileById(profileId)

    setAccessProfileByIdData(data)
  } catch (error) {
    const errorMessage =
      (error as AxiosError<{ errorMessage: string[] }>)?.response?.data?.errorMessage[0] ||
      'Falha ao buscar os perfis de acesso!'

    toast.error(errorMessage)
  } finally {
    setIsAccessProfileByIdLoading(false)
  }
}

const getProfiles = async (FormData: GetProfilesFormDataProps) => {
  const { setProfilesData, setIsProfilesLoading } = useAccessProfile.getState()

  setIsProfilesLoading(true)

  try {
    const payload = parseGetProfilesPaylod(FormData)

    const data = await apiAccessProfile.getProfiles(payload)

    setProfilesData(data)
  } catch (error) {
    const errorMessage =
      (error as AxiosError<{ errorMessage: string[] }>)?.response?.data?.errorMessage[0] ||
      'Falha ao buscar o perfil de acesso!'

    toast.error(errorMessage)
  } finally {
    setIsProfilesLoading(false)
  }
}

export { getProfiles, getAccessProfileById, savePermissions, addNewProfile, deleteProfile }
